import React from 'react';
import { Box, Text, SimpleGrid, VStack, Link, Image } from '@chakra-ui/react';
import { InstagramIcon } from 'lucide-react';
export function InstagramFeed() {
  const instagramImages = ['https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=400&q=80', 'https://cdn.magicpatterns.com/uploads/2RFsfzLJ2r2zq7NY8AcwC1/omar-lopez-buA5_3PDBXw-unsplash.jpg', 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=400&q=80', 'https://images.unsplash.com/photo-1583496661160-fb5886a0aaaa?w=400&q=80'];
  return <Box as="section" bg="white" py={{
    base: 16,
    md: 20
  }} px={{
    base: 6,
    md: 12,
    lg: 20
  }} data-id="element-111">
      <VStack spacing={10} maxW="1100px" mx="auto" data-id="element-112">
        {/* Section title */}
        <VStack spacing={2} textAlign="center" data-id="element-113">
          <Text as="h2" className="font-serif" fontSize={{
          base: '26px',
          md: '34px'
        }} fontWeight={700} color="#3A3A3A" data-id="element-114">
            Follow the Love 💕
          </Text>
          <Link href="#" className="font-body" fontSize="15px" fontWeight={500} color="#C9929D" textDecoration="none" display="flex" alignItems="center" gap={1} _hover={{
          textDecoration: 'underline'
        }} data-id="element-115">
            <InstagramIcon size={16} data-id="element-116" />
            @loveandxxs
          </Link>
          <Box w="60px" h="2px" bg="#F4B8C1" borderRadius="full" mt={1} data-id="element-117" />
        </VStack>

        {/* Instagram grid */}
        <SimpleGrid columns={{
        base: 2,
        md: 4
      }} spacing={{
        base: 3,
        md: 4
      }} w="100%" data-id="element-118">
          {instagramImages.map((src, i) => <Box key={i} aspectRatio="1/1" overflow="hidden" borderRadius="8px" border="2px solid" borderColor="rgba(244,184,193,0.4)" cursor="pointer" transition="all 0.25s" _hover={{
          borderColor: '#F4B8C1',
          transform: 'scale(1.02)',
          boxShadow: '0 4px 16px rgba(201,146,157,0.2)'
        }} bg="#F0F0F0" data-id="element-119">
              <Image src={src} alt={`Instagram post ${i + 1}`} w="100%" h="100%" objectFit="cover" fallback={<Box w="100%" h="100%" bg="linear-gradient(135deg, #FAE0E4 0%, #F5EDE0 100%)" display="flex" alignItems="center" justifyContent="center" data-id="element-121">
                    <InstagramIcon size={28} color="#C9929D" opacity={0.5} data-id="element-122" />
                  </Box>} data-id="element-120" />
            </Box>)}
        </SimpleGrid>

        {/* Follow link */}
        <Link href="#" className="font-body" fontSize="15px" fontWeight={600} color="#C9929D" textDecoration="none" display="flex" alignItems="center" gap={2} borderBottom="1px solid transparent" _hover={{
        borderBottomColor: '#C9929D',
        textDecoration: 'none'
      }} transition="border-color 0.2s" data-id="element-123">
          <InstagramIcon size={16} data-id="element-124" />
          Follow Us on Instagram →
        </Link>
      </VStack>
    </Box>;
}